import { createCrudContext } from "./_lib/createCrudContext";

const { Provider, useValue } = createCrudContext({
  name: "advertisement",
  adminPrefix: "",
  legacy: {
    data: "Advertisement",
    fetch: "fetchAdvertisements",
    create: "createOneAdvertisement",
    update: "updateAdvertisement",
    remove: "deleteAdvertisement",
    updateState: "updateAdvertisementState",
  },
});

export const AdvertisementProvider = Provider;
export const useAdvertisementContext = useValue;
